import React, {useEffect} from 'react';
import Head from 'next/head';
import type {AppProps} from 'next/app';
import {appWithTranslation, type UserConfig} from 'next-i18next';
import configNextI18Next from 'next-i18next.config';
import {config} from '@app/modules/config';
import AppRoot from '@components/AppRoot';
import type {PageProps} from '@app/types/next';
import {interFontFace, deezerProductFontFace} from '@app/utils/fontFace';

import './global.css';

const App: React.FC<AppProps<PageProps>> = ({Component, pageProps}) => {
	useEffect(() => {
		try {
			if (document.domain !== 'localhost') {
				// Used for some old browsers to enable some CORS stuff
				document.domain = config.get('cookieDomain').slice(1);
			}
		} catch {
			// Silently fail when running inside a sandboxed iframe (e.g. Kameleoon A/B test variations)
		}
	}, []);

	return (
		<>
			<Head>
				<style
					dangerouslySetInnerHTML={{__html: deezerProductFontFace}}
				></style>
				<style dangerouslySetInnerHTML={{__html: interFontFace}}></style>
				<link
					rel="icon"
					type="image/x-icon"
					href={`${config.get('appAssetsUrl')}/icons/favicon.ico`}
				/>
			</Head>
			<AppRoot {...pageProps}>
				<Component {...pageProps} />
			</AppRoot>
		</>
	);
};

export default appWithTranslation(
	App,
	configNextI18Next as unknown as UserConfig,
);
